import {Box, Image, Text, Flex, Icon} from '@chakra-ui/react'
import PracticePart from '@assets/images/gym/practice-part.png'
import PairPart from '@assets/images/gym/pair-part.png'
import PronouncePart from '@assets/images/gym/pronounce-part.png'
import {useNavigate} from 'react-router-dom'
import LockIcon from '@assets/svgs/roadmap/lock.svg'
import {ReactComponent as TickIcon} from '@assets/svgs/gym/tick.svg'
import {updateIsShowUpgradeModal} from '@redux/map/mapSlice'
import {useDispatch} from 'react-redux'
import {PATH} from '@utils/Const'
import {isLoggedIn} from '@utils'

interface LessonItem {
  lesson_id: string | number
  lesson_name: string
  is_finish?: boolean
  is_lesson_locked?: boolean
  pronounce_part: {type: string; is_lock: boolean}
  pair_part: {type: string; is_lock: boolean}
  practice_part: {type: string; is_lock: boolean}
}

const PronunciationCard = ({
  item,
  index,
}: {
  item: LessonItem
  index: number
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleNavigate = (
    path: string,
    lesson_id: string | number,
    lesson_name: string,
    type: string,
  ) => {
    if (!isLoggedIn()) {
      navigate(PATH.LOGIN)
      return
    }

    if (item.is_lesson_locked) {
      dispatch(updateIsShowUpgradeModal(true))
      return
    }

    navigate(path, {
      state: {lesson_id, lesson_name, type},
    })
  }

  const ExerciseButton = ({
    part,
    path,
    icon,
    title,
  }: {
    part: {type: string; is_lock: boolean}
    path: string
    icon: string
    title: string
  }) => (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="8px"
      fontWeight={700}
      cursor={part.is_lock ? 'default' : 'pointer'}
      color={part.is_lock ? '#ccc' : '#003D75'}
      style={{
        WebkitFilter: part.is_lock ? 'grayscale(100%)' : 'none',
      }}
      _hover={{
        color: part.is_lock ? undefined : '#0085ff',
      }}
      onClick={() =>
        !part.is_lock &&
        handleNavigate(path, item.lesson_id, item.lesson_name, part.type)
      }>
      <Image src={icon} w="64px" h="64px" borderRadius={'50%'} />
      <Text fontSize="12px" align="center" maxW="70px">
        {title}
      </Text>
    </Flex>
  )

  return (
    <Box
      key={index}
      p={{base: '16px', md: '20px'}}
      borderRadius="16px"
      bg="white"
      alignItems="center"
      _hover={{
        boxShadow: '0px 0px 8px 2px #ccc',
      }}
      transition="0.5s"
      border="1px solid #EFEFEF">
      <Flex
        p={'12px 16px'}
        borderRadius={'12px'}
        bg={item?.is_finish ? '#DAF1E0' : '#D1E9FF'}
        gap={'6px'}>
        <Flex alignItems={'center'} fontWeight={500} fontSize={'16px'}>
          {item.lesson_name}
        </Flex>
        {item?.is_lesson_locked ? (
          <Flex flexGrow={1} alignItems={'center'} justifyContent={'end'}>
            <Image src={LockIcon} w={'30px'} h={'30px'} />
          </Flex>
        ) : (
          item?.is_finish && (
            <Flex flexGrow={1} alignItems={'center'} justifyContent={'end'}>
              <Icon as={TickIcon} w={'24px'} h={'24px'} />
            </Flex>
          )
        )}
      </Flex>
      <Flex mt="20px" py="8px" gap="20px" justifyContent={'space-between'}>
        <ExerciseButton
          part={item.pronounce_part}
          path={PATH.GYM_PRONOUNCE}
          icon={PronouncePart}
          title="Hướng dẫn phát âm"
        />
        <ExerciseButton
          part={item.pair_part}
          path={PATH.GYM_PAIR}
          icon={PairPart}
          title="Phân biệt cặp từ"
        />
        <ExerciseButton
          part={item.practice_part}
          path={PATH.GYM_PRACTICE}
          icon={PracticePart}
          title="Luyện tập phát âm"
        />
      </Flex>
    </Box>
  )
}

export default PronunciationCard
